<div class="lpo-backdrop">
  <div class="lpo-panel" role="dialog" aria-modal="true" aria-labelledby="lpo-title">

    <div class="lpo-spinner" aria-hidden="true">
      <span class="lpo-spin"></span>
    </div>

    <div class="lpo-body" aria-live="polite">
      <p id="lpo-title" class="lpo-title">{{ 'LOGIN_POPUP.TITLE' | translate }}</p>
      <p class="lpo-sub">{{ 'LOGIN_POPUP.TEXT_1' | translate }}<br>{{ 'LOGIN_POPUP.TEXT_2' | translate }}</p>
    </div>

    <button class="lpo-cancel" type="button" (click)="auth.cancelPopup()">
      {{ 'LOGIN_POPUP.CANCEL' | translate }}
    </button>

  </div>
</div>
